export enum Variant {
  Primary = 'primary',
  Outline = 'outline',
}
